module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-ecostruxure-hero-lowres.dc75e31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-ecostruxure-hero-lowres.jpg
// module id = ZPu/
// module chunks = 0